import * as React from "react";
import { useState, useMemo, useContext } from "react";
const ModalContext = React.createContext(null);
export function ModalProvider({ children }) {
  const [modal, setModal] = useState();
  const [entity, setEntity] = useState();
  const value = useMemo(() => ({ modal, setModal, entity, setEntity }), [modal, entity]);
  return /* @__PURE__ */ React.createElement(ModalContext.Provider, { value }, children);
}
export function useModalContext() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
}
